// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agency_select[data-v-05c101c0]  .vs__dropdown-toggle{padding-bottom:0!important;padding-top:3px!important}.agency_select[data-v-05c101c0]  .vs__dropdown-toggle .vs__actions{display:none!important}", ""]);
// Exports
module.exports = exports;
